import { render } from "./PointList_client.vue?vue&type=template&id=4a193026"
import script from "./PointList_client.vue?vue&type=script&lang=js"
export * from "./PointList_client.vue?vue&type=script&lang=js"

import "./PointList_client.vue?vue&type=style&index=0&id=4a193026&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__